export enum SitePlatform {
  dstv = 'dstv',
  gotv = 'gotv',
}